<template>
    <div class="single-header">
        <secondary-header title="Customer Detail" backRoute="default"></secondary-header>

        <main>
            <div class="container select-bills">
                <div class="row justify-content-center">
                    <div class="col-md-10">
                        <div class="content pt-4">

                            <h4 class="text-uppercase font-weight-bold">
                                <span v-if="scan_type == 'out'">{{ lang('Leaving') }}</span>
                                <span v-else>{{ lang('Welcome To') }}</span>
                            </h4>

                            <h4 class="font-weight-bold">{{ branch.name }}</h4>
                            <input type="hidden" class="form-control" id="branch_ref_no" name="branch_ref_no">

                            <table width="100%">
                                <tr>
                                    <td>{{ lang('Date')}}</td>
                                    <td>:</td>
                                    <td>{{ dateUi(undefined, 'DD-MMM-YYYY') }}</td>
                                </tr>
                                <tr class="address">
                                    <td>{{ lang('Location')}}</td>
                                    <td>:</td>
                                    <td>{{ branch.address }}</td>
                                </tr>
                            </table>

                            <form class="py-4">
                                <div class="form-group">
                                    <label>{{ lang('Name') }}</label>
                                    <input type="text" class="form-control" :value="customer.name" disabled>
                                </div>
                                <div class="form-group">
                                    <label>{{ lang('Contact No.') }}</label>
                                    <input type="text" class="form-control" :value="customer.phone_no" disabled>
                                </div>

                                <div class="form-group">
                                    <label class="required">{{ lang('FUDC') }}</label>
                                    <select type="text" class="form-control" name="fudc_id" v-model="inputs.fudc_id" :disabled="state.loading_fudc_category">
                                        <option value="">-- select --</option>
                                        <option v-for="fudc in fudcs" :value="fudc.id" :key="fudc.id">{{ fudc.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label class="required">{{ lang('Industrial Sector') }}</label>
                                    <select type="text" class="form-control" name="checkin_type_id" v-model="inputs.checkin_type_id" :disabled="state.loading_fudc_category">
                                        <option value="">-- select --</option>
                                        <option v-for="checkin_type in checkin_types" :value="checkin_type.id" :key="checkin_type.id" v-if="checkin_type.category_id == selected_category_id">{{ checkin_type.name }}</option>
                                    </select>
                                </div>

                                <div v-if="questionnaires.length > 0" class="form-group">
                                    <label class="required">{{ lang('How did you hear about our event?') }}</label>
                                    <select type="text" class="form-control" name="questionnaire" v-model="inputs.questionnaire" :disabled="state.loading_questionnaire">
                                        <option value="">-- select --</option>
                                        <option v-for="questionnaire in questionnaires" :value="questionnaire" :key="questionnaire">{{ questionnaire }}</option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label for="remark">{{ lang('Remark / Enquiry') }}</label>
                                    <textarea type="text" class="form-control" id="remark" name="remark" v-model="inputs.remark" rows="4"></textarea>
                                </div>

                                <div class="py-3">
                                    <!-- {{ lang('By clicking on the "Submit" button, you hereby agree GoNet\'s :tnc & :policy', {tnc: '<a href="#" target="_black">Terms & Conditions</a>', policy:'<a href="#" target="_black">Privacy Policy</a>'}) }} -->
                                    By clicking on the "Submit" button, you hereby confirm that all the above information is true and agree GoNet's <a href="https://www.gonet.my/terms-conditions/" target="_blank" class="text-primary">Terms and Conditions</a> & <a href="https://www.gonet.my/privacy-policy/" target="_blank" class="text-primary">Privacy Policy</a>
                                </div>
                            </form>

                            <float-bottom>
                                <button type="button" class="btn btn-danger" @click.prevent="goBack(-1)">{{ lang('Cancel') }}</button>
                                <button type="button" class="btn btn-primary btn-block" :disabled="!can_submit" @click="submitTemp">{{ lang('Submit') }}</button>
                            </float-bottom>
                        </div>
                    </div>
                </div>
            </div>

            <main-footer></main-footer>
            <loader v-if="state.loading"></loader>
        </main>
    </div>
</template>

<script>


export default {
    props: ['branch', 'scan_type'],
    data() {
        return {
            customer: {},
            inputs: {
                remark: '',
                temperature: '',
                fudc_id: '',
                checkin_type_id: '',
                questionnaire: '',
            },
            fudcs: {},
            checkin_types: {},
            silently_fudc: false,
            questionnaires: [],
        }
    },

    watch: {
        'inputs.fudc_id': function() {
            if(!this.silently_fudc) {
                this.inputs.checkin_type_id = ''
            }
            this.silently_fudc = false
        }
    },

    computed: {
        can_submit: function() {
            return true;
        },

        selected_category_id: function() {
            if(this.inputs.fudc_id) {
                var fudc = this.fudcs.find((x) => x.id == this.inputs.fudc_id)
                return fudc ? fudc.category_id : ''
            }
            return ""
        }
    },

    methods: {
        submitTemp() {
            fireLoader()
            axios.post(this.GLOBAL.API_BASE_URL +"branch-visit", {
                    temperature: this.inputs.temperature,
                    remark: this.inputs.remark,
                    category_id: this.selected_category_id,
                    fudc_id: this.inputs.fudc_id,
                    checkin_type_id: this.inputs.checkin_type_id,
                    branch_ref_no: this.branch.reference_no,
                    scan_type: this.scan_type,
                    questionnaire: this.inputs.questionnaire,
                })
                .then(response => {
                    if(response.data == 'OK') {
                        Swal.fire({
                            // type: 'error',
                            imageUrl: require('@/assets/mascot_tq.png'),
                            text: this.lang('Thanks For Visiting Us'),
                            timer: 5000
                        })
                        localStorage.setItem("fudc_id", this.inputs.fudc_id)
                        localStorage.setItem("checkin_type_id", this.inputs.checkin_type_id)
                        this.$router.replace({name: 'history'})
                    } else {
                        Swal.fire({
                            // type: 'error',
                            text: 'Something wrong. Please try again',
                            timer: 5000
                        })
                    }
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                // .finally(() => Swal.close())
        },

        getCustomer() {
            this.$set(this.state, 'loading', true)
            axios.get(this.GLOBAL.API_BASE_URL +"current-customer")
                .then(response => {
                    this.customer = response.data
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading', false))
        },

        getFudcAndCategory() {
            this.$set(this.state, 'loading_fudc_category', true)
            axios.post(this.GLOBAL.API_BASE_URL +"fudc-n-checkintype-list", {
                    branch_ref_no: this.branch.reference_no
                })
                .then(response => {
                    this.fudcs = response.data.fudcs
                    this.checkin_types = response.data.checkin_types

                    if(localStorage.getItem("fudc_id")) {
                        if(this.fudcs.find((x) => x.id == localStorage.getItem("fudc_id"))) {
                            this.silently_fudc = true
                            this.inputs.fudc_id = localStorage.getItem("fudc_id")
                        }
                    }
                    if(localStorage.getItem("checkin_type_id") && this.inputs.fudc_id) {
                        this.inputs.checkin_type_id = localStorage.getItem("checkin_type_id")
                    }
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_fudc_category', false))
        },

        getQuestionnaire() {
            this.$set(this.state, 'loading_questionnaire', true)
            axios.post(this.GLOBAL.API_BASE_URL +"questionnaire-list", {
                    branch_ref_no: this.branch.reference_no
                })
                .then(response => {
                    this.questionnaires = response.data
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_questionnaire', false))
        }
    },

    created() {
        if(this.branch == undefined) {
            this.closeApp()
        }

        this.getCustomer()
        this.getFudcAndCategory()
        this.getQuestionnaire()
    },

    beforeRouteEnter (to, from, next) {
        if(to.params.branch == undefined) {
            next({name: 'auth', replace: true})
        }
        else {
            next()
        }
    },

    beforeRouteLeave(to, from, next) {
        if(to.name == 'auth') {
            this.closeApp()
        } else {
            next()
        }
    }
}
</script>

<style lang="scss" scoped>
    .button {
        font-size: 0.85rem;
        padding: 3px;

        .info {
            font-size: 0.7rem;
        }
    }

    .address {
        td {
            vertical-align: top;
        }
    }
</style>
